var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import Styles from './input-styles.scss';
import React, { useRef } from 'react';
const Input = (_a) => {
    var { state, setState } = _a, props = __rest(_a, ["state", "setState"]);
    const inputRef = useRef();
    const error = state[`${props.name}Error`];
    const isFormDirty = state.dirtyFields ? state.dirtyFields[props.name] : true;
    const changeValue = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setState(Object.assign(Object.assign({}, state), { [e.target.name]: e.target.value, dirtyFields: Object.assign(Object.assign({}, state.dirtyFields), { [e.target.name]: true }) }));
        if (props.maxcharacters > 0 && value.length > props.maxcharacters) {
            inputRef.current.value = value.slice(0, -1);
        }
    };
    const LabelInput = () => {
        return (React.createElement("label", { className: props.label ? Styles.labelInput : Styles.labelPlaceholder, "data-testid": `${props.name}-label`, onClick: () => {
                if (!props.label)
                    inputRef.current.focus();
            }, title: error }, props.label ? props.label : props.placeholder));
    };
    return (React.createElement("div", { "data-testid": `${props.name}-wrap`, className: Styles.inputWrap, "data-status": error && isFormDirty ? 'invalid' : 'valid' },
        React.createElement(LabelInput, null),
        React.createElement("input", Object.assign({}, props, { ref: inputRef, title: error, placeholder: props.label ? props.placeholder : ' ', "data-testid": props.name, readOnly: true, onFocus: e => {
                e.target.readOnly = false;
            }, onChange: e => {
                changeValue(e);
            } }))));
};
export default Input;
